export function resolveInviteVerifyId(query = {}) {
  return String(query.verify_id || '').trim();
}

export function isMemberInviteView(query = {}) {
  return String(query.view || '') === 'member_invite';
}

/** 邀请链路中途掉登录态：回到邀请扫码，不要退普通登录 */
export function loginLocationWithInvite(query = {}) {
  const verifyId = resolveInviteVerifyId(query);
  if (!verifyId) {
    return { path: '/login' };
  }
  if (isMemberInviteView(query)) {
    return {
      path: '/login',
      query: {
        view: 'member_invite',
        step: '1',
        verify_id: verifyId,
      },
    };
  }
  return {
    path: '/login',
    query: {
      view: 'invite',
      step: '1',
      verify_id: verifyId,
    },
  };
}
